import styled from "styled-components";

export const NotificationArea = styled.div`
  display: grid;
  row-gap: 1rem;
  grid-template-columns: 1fr;
  margin-top: 1rem;
`;
